import * as React from "react";
import { useTranslation } from "react-i18next";

import workflowStyle from "./all-workflows-table.scss";
import Import from "components/icons/Import";
import Modal from "components/modal/Modal";
import ImportWorkflowsDialog from "components/workflows/ImportWorkflowsDialog";
import { UserDetails } from "domain/user";
import { Action, Category, usageStatisticsService } from "services/statistics/UsageStatisticsService";
import { workflowService } from "services/workflows/WorkflowService";
import buttons from "styles/buttons.scss";
import { useTheme } from "utils/useTheme";

import testIds from "testIds.json";

interface Props {
    user: UserDetails | null;
    onUpdate: () => void;
}

const ImportWorkflowView: React.FunctionComponent<Props> = (props: Props) => {
    const { t } = useTranslation();
    const [modalVisible, setModalVisible] = React.useState(false);
    const colourTheme = useTheme();
    const hideModal = () => {
        setModalVisible(false);
        setModalTitleIcon(undefined);
        props.onUpdate();
    };
    const [modalTitle, setModalTitle] = React.useState<string>(t("ImportWorkflowDialog.title"));
    const [modalTitleIcon, setModalTitleIcon] = React.useState<JSX.Element | undefined>(undefined);

    return (
        <>
            <button
                className={buttons.secondaryButton}
                onClick={() => {
                    usageStatisticsService.sendEvent({
                        category: Category.WORKFLOW,
                        action: Action.IMPORT_WORKFLOW,
                    });
                    setModalVisible(true);
                }}
                data-testid={testIds.workArea.workflows.importWorkflowButton}
            >
                <Import color={colourTheme.iconFillColor} />
                <span className={workflowStyle.buttonText}>{t("WorkflowsTable.actions.import.button")}</span>
            </button>
            <Modal
                key={1}
                isOpen={modalVisible}
                hideModal={hideModal}
                modalTitle={modalTitle}
                titleIcon={modalTitleIcon}
            >
                <ImportWorkflowsDialog
                    onClose={hideModal}
                    service={workflowService}
                    setModalTitle={setModalTitle}
                    setModalTitleIcon={setModalTitleIcon}
                />
            </Modal>
        </>
    );
};

export default ImportWorkflowView;
